import { useSearchParams } from 'react-router';

export function useSearchParamState<TResult>(parser: (data: unknown) => TResult) {
  const [searchParams, setSearchParams] = useSearchParams();

  function setValue(key: keyof TResult, value: string | undefined) {
    setSearchParams(params => {
      if (value === undefined) {
        params.delete(key as string);
      } else {
        params.set(key as string, value);
      }
      return params;
    });
  }

  const values = parser(Object.fromEntries(searchParams));

  return {
    setValue,
    values,
  };
}
